// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  defaultContext,
  QueryClient,
  QueryClientProvider
} from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@16.14.0/node_modules/@tanstack/react-query';

import { reactQuery as reactQueryConfig } from '@/app';
const client = new QueryClient(reactQueryConfig.queryClient || {});
export function rootContainer(container) {
  return (
    <QueryClientProvider
      client={client}
      context={defaultContext}
    >
      {container}
      
    </QueryClientProvider>
  );
}
